import { useMemo } from "react";
import { useConsultantsListContent } from "@tecnobit-srl/consultancies-content-types-consultants-list/lazy";
import { useSuggestedConsultantsContent } from "@tecnobit-srl/consultancies-content-types-suggested-consultants/lazy";
import { useConsultantDetailContent } from "@tecnobit-srl/consultancies-content-types-consultant-detail/lazy";
import { useConsultantReviewsContent } from "@tecnobit-srl/consultancies-content-types-consultant-reviews/lazy";
import { useConsultancyBookingContent } from "@tecnobit-srl/consultancies-content-types-consultancy-booking/lazy";
import { useConsultancyRequestsContent } from "@tecnobit-srl/consultancies-content-types-consultancy-requests/lazy";
//#region src/index.ts
var useConsultanciesContentTypes = () => {
	const consultantsList = useConsultantsListContent();
	const suggestedConsultants = useSuggestedConsultantsContent();
	const consultantDetail = useConsultantDetailContent();
	const consultantReviews = useConsultantReviewsContent();
	const consultancyBooking = useConsultancyBookingContent();
	const consultancyRequests = useConsultancyRequestsContent();
	return useMemo(() => ({
		...consultantsList,
		...suggestedConsultants,
		...consultantDetail,
		...consultantReviews,
		...consultancyBooking,
		...consultancyRequests
	}), [
		consultantsList,
		suggestedConsultants,
		consultantDetail,
		consultantReviews,
		consultancyBooking,
		consultancyRequests
	]);
};
//#endregion
export { useConsultanciesContentTypes };
